export default "__VITE_ASSET__Fw7iCmUO__"